// extracted by mini-css-extract-plugin
module.exports = {"othersSaying":"othersSaying_othersSaying__UqvhN"};